import {
  MEETING_TEMPLATE_COLORS,
  type MeetingTemplateColor,
} from '@wundo/shared/meetingTemplate.ts';
import type { TypePillProps } from '../type-pill/type-pill.tsx';

/*
 * A stored colour and the pill the design system draws for it are two
 * vocabularies for one palette. One table, read both ways, so the picker and
 * the pill can never disagree. Not every pill is a template colour (a journey is not).
 */
const VARIANT_BY_COLOR: Record<MeetingTemplateColor, TypePillProps['type']> = {
  navy: 'oneOnOne',
  green: 'functionering',
  pink: 'disfunctionering',
  purple: 'reintegratie',
  teal: 'selectie',
  grey: 'none',
};

export function templateColorVariant(color: MeetingTemplateColor): TypePillProps['type'] {
  return VARIANT_BY_COLOR[color];
}

export function templateColorOf(variant: TypePillProps['type']): MeetingTemplateColor {
  const color = MEETING_TEMPLATE_COLORS.find(
    (candidate) => VARIANT_BY_COLOR[candidate] === variant,
  );
  if (!color) {
    throw new Error(`No template colour is drawn as the ${variant} pill`);
  }
  return color;
}
